import {
  FormRules,
  countryList,
} from '../../utils/form'
import { i18n } from '../../lang'

export const feedColumnList = [
  { type: 'id', custom: { width: '54' } },
  { type: 'slug', custom: { 'min-width': '150' }, title: `${i18n.t('table.slug')} (en)` },
  { type: 'brands', custom: { width: '120' } },
  { type: 'categories', custom: { width: '140' } },
  { type: 'stores', custom: { width: '140' } },
  { type: 'product_ids', custom: { width: '120' } },
  { type: 'available_countries', custom: { width: '148' } },
  { type: 'keywords', custom: { width: 100 } },
  { type: 'genders', custom: { width: 100 } },
  { type: 'min_price', custom: { width: 100 }, title: `${i18n.t('table.min_price_usd')}` },
  { type: 'max_price', custom: { width: 100 }, title: `${i18n.t('table.max_price_usd')}` },
  { type: 'discount_from', custom: { width: 100 } },
  { type: 'SEO', custom: { width: '46' } },
]

const formRules = {
  required: [FormRules.required],
  requiredChange: [FormRules.requiredChange],
  id: [FormRules.required, FormRules.id],
  countries: [FormRules.requiredCountries],
}

export const feedFormTemplate = [
  {
    key: 'slug',
    isLocalized: true,
    isDynamicLanguage: true,
    rules: formRules.required,
  },
  {
    key: 'brands',
    isSlot: true,
  },
  {
    key: 'categories',
    isSlot: true,
  },
  {
    key: 'stores',
    isSlot: true,
  },
  {
    key: 'keywords',
    isSelect: true,
    custom: {
      multiple: true,
      allowCreate: true,
      filterable: true,
      class: 'w-100',
      noDataText: 'Enter new keyword and select from the dropdown',
    },
  },
  {
    key: 'genders',
    isSelect: true,
    list: [
      {
        label: 'Men',
        value: 'M',
      },
      {
        label: 'Women',
        value: 'W',
      },
      {
        label: 'Kids',
        value: 'K',
      },
    ],
    custom: { multiple: true, class: 'w-100' },
  },
  {
    key: 'min_price',
    isInput: true,
    title: i18n.t('table.min_price_usd'),
    rules: [FormRules.nonNegativeNumber],
  },
  {
    key: 'max_price',
    isInput: true,
    title: i18n.t('table.max_price_usd'),
    rules: [FormRules.nonNegativeNumber],
  },
  {
    key: 'discount_from',
    isSelect: true,
    list: [
      {
        label: '20% Off',
        value: 20,
      },
      {
        label: '30% Off',
        value: 30,
      },
      {
        label: '50% Off',
        value: 50,
      },
      {
        label: '70% Off',
        value: 70,
      },
    ],
  },
  {
    key: 'product_ids',
    isSlot: true,
  },
  {
    key: 'available_countries',
    isCheckbox: true,
    title: i18n.t('table.availableCountries'),
    list: countryList,
  },
]

